import React from 'react'
import ExperienceItem from './ExperienceItem'

function Publications() {
  return (
    <div className='w-full lg:w-[60%] min-h-screen py-12 lg:py-20 px-6 lg:px-20 bg-white relative lg:left-[300px]'>
        <p className='w-full text-black text-sm text-left py-2'>
            I do sometime author or co-author some white paper, journals if the technology or concept interest me.
        </p>
        <div className='w-full py-4 flex flex-col items-center'>
            <ExperienceItem 
              title='NER Based Law Entity Privacy Protection'
              company='International Journal of Scientific Research in Computer Science, Engineering and Information Technology'
              started='Dec 2023'
              ended={'Dec 2023'}
              isCompleted={true}
              tech={['Privacy','Security','Legal AI']}
              responsibilities={[]}
              link='https://res.ijsrcseit.com/page.php?param=CSEIT2390665'
            />
          </div>
    </div>
  )
}

export default Publications